import { ReactNode, useMemo } from 'react';
import styles from './FiltersLayout.css';
import { Filter } from './components/Filter';
import { Group } from './components/Group';
import { TFilter } from 'shared/types/filters';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { useSelector } from 'react-redux';

interface IFilter {
  id: TFilter;
  component: ReactNode;
}

interface IFiltersLayoutProps {
  filters: IFilter[];
  applyButton: React.ReactNode;
  searchButton: React.ReactNode;
  tags: React.ReactNode;
}

export const FiltersLayout: React.FC<IFiltersLayoutProps> = ({ filters, applyButton, tags, searchButton }) => {
  const { mainFilters, geoFilter } = useMemo(
    () => ({
      mainFilters: filters.filter(({ id }) => id !== 'geo'),
      geoFilter: filters.find(({ id }) => id === 'geo')?.component,
    }),
    [filters],
  );

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <div className={isFiltersRedesignEnabled ? styles['redisined_container'] : styles['container']}>
      <div className={isFiltersRedesignEnabled ? styles['redisigned_layout'] : styles['layout']}>
        <div className={styles['filters']}>
          <Group>
            {mainFilters.map(({ id, component }) => (
              <Filter key={`filter_${id}`} dataTestId={id}>
                {component}
              </Filter>
            ))}
          </Group>

          <Group>
            <Filter className={styles['geo']}>{geoFilter}</Filter>

            <div className={styles['button']}>{applyButton}</div>

            <div className={styles['button']}>{searchButton}</div>
          </Group>
        </div>
        <div className={styles['tags']}>{tags}</div>
      </div>
    </div>
  );
};
